import * as Common from '@/tenant/common';

export class Invoice extends Common.StateObject{
  constructor(){
    super('Invoice')
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.bankAccount = new Common.ModelBinder(Common.BankAccount);
    this.binders.billedBalance = new Common.ModelBinder(Common.TransferBalance);
    this.workflowCode="invoice";
    this.workflowStateId = 1;
  }
  public get actionTooltip() {
    if (this.state == InvoiceStatus.CarryOverWaiting)　return '当月の請求を締める場合は、先に過去の請求を締める必要があります。検索条件で得意先を指定して、過去の繰越請求書を一覧に表示します。請求締日欄の日付が古い順に【請求締処理】をクリックします。';
    else if (this.state == InvoiceStatus.CarryOverClosingWaiting) return '当月の請求を締め、売上を計上する場合は【請求締処理】をクリックします。';
    else if (this.state == InvoiceStatus.CarryOverCompleted) return '請求を訂正する場合は【締取消処理】をクリックします。';     

    else if (this.state == InvoiceStatus.AloneClosingWaiting)　return '売上を計上し、入金へ進む場合は【請求締処理】をクリックします。';
    else if (this.state == InvoiceStatus.AloneReceiptWaiting) return '入金を行う場合は【上部メニュー】の【入金処理】をクリックします。';
    else if (this.state == InvoiceStatus.AlonePartReceipt) return '入金を行う場合は【上部メニュー】の【入金処理】をクリックします。';     
    else if (this.state == InvoiceStatus.AloneCompleted) return '請求を訂正する場合は、作成した入金伝票を削除してから【締取消処理】をクリックします。';       
    else if (this.state == InvoiceStatus.AloneCompletedNoAmount) return '請求を訂正する場合は【締取消処理】をクリックします。';      

    else if (this.state == InvoiceStatus.PurchasePostWaiting)　return '仕入を計上し、支払へ進む場合は【仕入計上】をクリックします。';
    else if (this.state == InvoiceStatus.PurchasePaymentWaiting) return '支払を行う場合は【上部メニュー】の【支払処理】をクリックします。';
    else if (this.state == InvoiceStatus.PurchasePaying) return '支払を行う場合は【上部メニュー】の【支払処理】をクリックします。';     
    else if (this.state == InvoiceStatus.PurchaseCompleted) return '計上内容を訂正する場合は、作成した支払伝票を削除してから【確定取消】をクリックします。';   
    else if (this.state == InvoiceStatus.PurchaseCompletedWithoutPayment) return '計上内容を訂正する場合は【確定取消】をクリックします。';       
    else return '';
  }       
  public get messageOnEdit():string { 
    switch(this.state){
      case InvoiceStatus.AloneReceiptWaiting: 
      case InvoiceStatus.AloneCompletedNoAmount : return '「締取消処理」をクリックして状態を「請求締待ち」に戻してから編集してください。';
      case InvoiceStatus.AlonePartReceipt: 
      case InvoiceStatus.AloneCompleted : return '入金処理が行われているため編集できません。\r\n編集する場合は、【関連伝票】で表示される入金伝票をすべて削除してから、「締取消処理」をクリックしてください。';
      case InvoiceStatus.PurchasePaymentWaiting: 
      case InvoiceStatus.PurchaseCompletedWithoutPayment : return '「計上取消」をクリックして状態を「仕入計上待ち」に戻してから編集してください。';
      case InvoiceStatus.PurchasePaying: 
      case InvoiceStatus.PurchaseCompleted: return '支払処理が行われているため編集できません。\r\n編集する場合は、先に【関連伝票】で表示される支払伝票をすべて削除してから、「確定取消」をクリックしてください。';
      default: return super.messageOnEdit;
    }
  }
  public get messageOnDelete():string { 
    switch(this.state){
      case InvoiceStatus.AloneReceiptWaiting: 
      case InvoiceStatus.AloneCompletedNoAmount : return '「締取消処理」をクリックして状態を「請求締待ち」に戻してから削除してください。';
      case InvoiceStatus.AlonePartReceipt: 
      case InvoiceStatus.AloneCompleted : return '入金処理が行われているため削除できません。\r\n削除する場合は、先に【関連伝票】で表示される入金伝票をすべて削除してから、「締取消処理」をクリックしてください。';
      case InvoiceStatus.PurchasePaymentWaiting: 
      case InvoiceStatus.PurchaseCompletedWithoutPayment : return '「計上取消」をクリックして状態を「仕入計上待ち」に戻してから削除してください。';
      case InvoiceStatus.PurchasePaying: 
      case InvoiceStatus.PurchaseCompleted: return '支払処理が行われているため削除できません。\r\n削除する場合は、先に【関連伝票】で表示される支払伝票をすべて削除してから、「確定取消」をクリックしてください。';
      default: return super.messageOnDelete;
    }
  }
  public get messageOnActionMissing():string{
    if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return '入金処理が行われているため、ワークフロー操作は行えません。';
    else return '支払処理が行われているため、ワークフロー操作は行えません。';
  }    
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>入金処理待ち・完了(残高なし)
    if (actionFlag == Common.DefaultActionFlags.edit && (stateId == InvoiceStatus.AloneReceiptWaiting || stateId == InvoiceStatus.AloneCompletedNoAmount))
      return InvoiceStatus.AloneClosingWaiting;
    //削除=>完了
    else if (actionFlag == Common.DefaultActionFlags.delete && (stateId == InvoiceStatus.AloneReceiptWaiting || stateId == InvoiceStatus.AloneCompletedNoAmount))
      return InvoiceStatus.AloneClosingWaiting;
    //更新=>請求締待ち
    else if (actionFlag == Common.DefaultActionFlags.update && stateId == InvoiceStatus.AloneClosingWaiting)
      return InvoiceStatus.AloneReceiptWaiting;
    //編集=>支払処理待ち・完了(残高なし)
    if (actionFlag == Common.DefaultActionFlags.edit && (stateId == InvoiceStatus.PurchasePaymentWaiting || stateId == InvoiceStatus.PurchaseCompletedWithoutPayment))
      return InvoiceStatus.PurchasePostWaiting;
    //削除=>完了
    else if (actionFlag == Common.DefaultActionFlags.delete && (stateId == InvoiceStatus.PurchasePaymentWaiting || stateId == InvoiceStatus.PurchaseCompletedWithoutPayment))
      return InvoiceStatus.PurchasePostWaiting;
    //更新=>仕入計上待ち
    else if (actionFlag == Common.DefaultActionFlags.update && stateId == InvoiceStatus.PurchasePostWaiting)
      return InvoiceStatus.PurchasePaymentWaiting;      
    else
      return 0;
  }     

  public id: number= 0;
  public salesPurchaseFlag:Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Sales;  
  public counterpartId: number = 0;
  public counterpart: Common.Counterpart = null
  public segmentId: number = null;
  public segment: Common.Segment = null;
  public invoiceNo: string = '';
  public get voucherNo() {
    return this.invoiceNo;
  }
  public refNo: string = '';
  public invoiceType: number = 0;
  public closed: boolean = false;
  public closingDate: Date = new Date().getCalendarDate();
  public dueDate: Date = null;
  public settlement: SettlementTypes = null;
  public bankAccountCode: string = null;
  public bankAccount: Common.BankAccount = null;
  public commissionAmountFC: number = 0;
  public taxType: Common.TaxTypes = null;
  public paymentTerm: string = null;
  public currencyCode: string = '';
  public remark: string = '';
  
  // 金額
  public exchangeRate: number = 1;
  public previousAmountFC: number = 0;
  public receiptAmountFC: number = 0;
  public billedBalanceAmountFC: number = 0;
  public rolloverAmountFC:number = 0;
  public amountFC: number = 0;
  public taxAmountFC: number = 0;
  public totalAmountFC: number = 0;
  public amount: number = 0;
  public taxAmount: number = 0;
  public totalAmount: number = 0;
  public currentAmountFC: number = 0;
  public pendingBalanceAmountFC:number = 0;
  public purchaseCurrentAmountFC:number = 0;
  public payemntAmountFC: number = 0;  
  // EC連携、現金清算済み金額
  public cashReceived: number = 0;
  // 請求残高管理
  public billedBalanceId: number = 0;
  public billedBalance: Common.TransferBalance = null;
  public writeoffAmountFC: number = 0;  

  public previousReceiptAmountFC:number = 0;
  public nextRolloveredAmountFC:number = 0;
  public rolloverFlag : RolloverFlags = RolloverFlags.none;
  public rolloverTarget(tenantSettings: Common.TenantSettings) : boolean{
    if(this.currentAmountFC == 0)return false;
    if(this.invoiceType == InvoiceTypes.SeparateInvoice)return false;
    if((tenantSettings && tenantSettings.paymentLaterCarryOverTarget == false) && (this.counterpart.paymentMonth1 >= Common.MonthTypes.Month2Later || this.counterpart.paymentMonth2 >= Common.MonthTypes.Month2Later))return false;
    return true;
  };

  // 揮発性フィールド
  public designationReportTemplateId: number = null; // 指定帳票
}
export enum RolloverFlags
{
        none = 0,       
        previous = 1,
        next = 2,
        transfer = 4,
        both = previous | next,  
        transferNext = transfer | next,
}
export enum RolloverPerformFlags
{
        none = 0,
        perform = 1,
        notPerform = 2,
}
export enum InvoiceStatus
{
  CarryOver = 1, // 請求(繰越あり)
  Alone = 2, // 請求(繰越なし・個別)
  Purchase = 4, // 仕入計上

  CarryOverWaiting = CarryOver + 32, // 繰越待ち
  CarryOverClosingWaiting = CarryOver + 64, // 請求締待ち(繰越あり)
  CarryOverCompleted = CarryOver + 128, // 完了(繰越あり)
  CarryOverNotCompleted = CarryOverWaiting | CarryOverClosingWaiting, // 完了以外(繰越あり)

  AloneClosingWaiting = Alone + 32, // 請求締待ち(繰越なし)
  AloneReceiptWaiting = Alone + 64, // 入金処理待ち
  AlonePartReceipt = Alone + 128, // 入金処理中
  AloneCompleted = Alone + 256, // 完了(繰越なし、請求金額>0)
  AloneCompletedNoAmount = Alone + 512, // 完了(繰越なし、請求金額=0)
  AloneCompletedIncludingNoAmount = AloneCompleted | AloneCompletedNoAmount, // 完了(繰越なし)
  AloneNotCompleted = AloneClosingWaiting | AloneReceiptWaiting | AlonePartReceipt, // 完了以外(繰越なし)

  PurchasePostWaiting = Purchase + 32,//仕入計上待ち
  PurchasePaymentWaiting = Purchase + 64,//支払処理待ち
  PurchasePaying = Purchase + 128,//支払処理中
  PurchaseCompleted = Purchase + 256,//完了
  PurchaseCompletedWithoutPayment  = Purchase + 512,//完了(支払なし),
  PurchaseNotCompleted = PurchasePostWaiting | PurchasePaymentWaiting | PurchasePaying,//完了以外
  PurchaseCompletedAll = PurchaseCompleted | PurchaseCompletedWithoutPayment,//完了
}

export enum InvoiceTypes {
  None = 0,
  ConsolidateInvoiceCarryOver = 1,//締請求(繰越あり)
  ConsolidateInvoice = 2,//締請求(繰越なし)
  SeparateInvoice = 3,//個別請求
  PurchasePost = 10, //仕入計上
  PurchaseTransit = 11, //未着品計上
}

export enum SettlementTypes
{
  ByReceivable = 1,
  ByCash = 2,
  ByPayable = 3
}

export class CarryOverInvoice extends Invoice{
  constructor(){
    super()
    this.workflowCode="carryOverInvoice";
    this.state = 1;
    this.workflowStateId = 1;
  }
}

export class AloneInvoice extends Invoice{
  constructor(){
    super()
    this.workflowCode="aloneInvoice";
    this.state = 8;
    this.workflowStateId = 8;
  }
}

export class InvoiceQuery extends Common.LoadQuery {
  constructor(carryOverFlag:boolean){
    super('InvoiceQuery',Invoice);
    this.sort = 'invoiceNo';
    this.carryOverFlag = carryOverFlag;
    this.state = carryOverFlag ? Common.InvoiceStatus.CarryOverNotCompleted : Common.InvoiceStatus.AloneNotCompleted;
  }
  public carryOverFlag: boolean = true;
  public segment: Common.Segment = null;
  public counterpartClosingDate: Common.DateTypes;
  public counterpart: Common.Counterpart = null;
  public closingDateFrom: Date = null;
  public closingDateTo: Date = null;
  public dueDateFrom: Date = null;
  public dueDateTo: Date = null;
  public invoiceNo: string = '';
  public refNo: string = '';
  public bankAccount: Common.BankAccount = null;
  public currencyCode : string = '';
  public dealAmountFcFrom: number = null;
  public dealAmountFcTo: number = null;
  public state: Common.InvoiceStatus = Common.InvoiceStatus.AloneClosingWaiting;
  public holder: string = '';
  public salesPurchaseFlag:Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Sales;    
  public invoiceType: InvoiceTypes = null;
  public rolloverPerformFlag: RolloverPerformFlags = 0;


  //日付フラグ
  public closingDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public closingDateToFlag : Common.dateFlags = Common.dateFlags.default;
  public dueDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public dueDateToFlag : Common.dateFlags = Common.dateFlags.default;      
}
export class PurchaseInvoiceQuery extends InvoiceQuery {
  constructor(){
    super(false);
    this.sort = 'invoiceNo';
    this.salesPurchaseFlag = Common.SalesPurchaseFlags.Purchase;
    this.state = Common.InvoiceStatus.PurchaseNotCompleted;
  }  
}

export class InvoiceImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, salesPurchaseFlag:number){
    super("",null);
    this.className = "InvoiceImportQuery";
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
}
export class InvoiceExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, carryOverFlag:boolean, salesPurchaseFlag:Common.SalesPurchaseFlags){
    super("",loadQuery);
    this.className = "InvoiceExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.carryOverFlag = carryOverFlag;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public carryOverFlag : boolean;
  public hasLicenseCurrency: boolean = false;
  public salesPurchaseFlag: Common.SalesPurchaseFlags;
}

export class BilledReceiptQuery extends Common.Query {
  constructor(){
        super('BilledReceiptQuery',null);
    }
    public salesPurchaseFlag:Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Sales;        
    public isCarryOverInvoice: boolean = false;
    public segment: Common.Segment = null;
    public pic: string = "";
    public counterpart: Common.Counterpart;
    public currencyCode: string;
    public receiptDate: Date;
    public bankAccount: Common.BankAccount = null;
    public description: string;
    public exchangeRate: number = 0;
    public commissionAmountFC: number = 0;
    public settlementAmountFC: number = 0;
    public commissionTaxFlag: boolean = true;
    public workflowId:number = 0;
    public invoices: Array<Common.Invoice>;
    public actionId:number = 0;
} 

export class AdvanceJouralQuery extends Common.LoadQuery {
  constructor(){
        super('AdvanceJouralQuery',Invoice);
    }
    public invoice: Invoice;
} 

export class AdvanceWriteoffAddQuery extends Common.Query {
  constructor(){
        super('AdvanceWriteoffAddQuery',new Common.ModelBinder(Invoice,false));
    }
    public invoice: Invoice;
    public orders: Array<Common.Order>;
} 

export class AdvanceWriteoffDeleteQuery extends Common.Query {
  constructor(){
        super('AdvanceWriteoffDeleteQuery',new Common.ModelBinder(Invoice,false));
    }
    public transferJournal: Common.TransferJournal;
} 

export class InvoiceDeleteQuery extends Common.Query {
  constructor(items: Array<Invoice>){
        super('InvoiceDeleteQuery', null);
        this.items = items;
    }
    public items: Array<Invoice>;
} 

export class InvoiceRolloverQuery extends Common.Query {
  constructor(items: Array<Invoice>, cancel : boolean){
        super('InvoiceRolloverQuery', new Common.ModelBinder(Invoice,true));
        this.items = items;
        this.cancel = cancel;
    }
    public items: Array<Invoice>;
    public cancel : boolean = false;
} 

export class InvoiceJournalTargetQuery extends Common.Query {
  constructor(invoice: Common.Invoice){
        super('InvoiceJournalTargetQuery',new Common.ModelBinder(Common.TransferJournal, true));
        this.invoice = invoice;
    }
    public invoice : Common.Invoice;

}
export class InvoiceJournalUpdateQuery extends Common.Query {
  constructor(invoice: Common.Invoice,isDelete:boolean, journals : Array<Common.TransferJournal>){
        super('InvoiceJournalUpdateQuery',new Common.ModelBinder(Common.Invoice, false));
        this.invoice = invoice;
        this.isDelete = isDelete;        
        this.journals = journals;
    }
    public invoice : Common.Invoice;
    public journals : Array<Common.TransferJournal>;
    public isDelete:boolean;
}